import { Equatable } from "@siteimprove/alfa-equatable";
import { Serializable } from "@siteimprove/alfa-json";
/**
 * A non-numerical value, e.g., orientation.
 *
 * @public
 */
export class Discrete {
    static of(value) {
        return new Discrete(value);
    }
    _value;
    constructor(value) {
        this._value = value;
    }
    get value() {
        return this._value;
    }
    map(mapper) {
        return new Discrete(mapper(this._value));
    }
    matches(value) {
        return Equatable.equals(this._value, value);
    }
    hasValue(refinement) {
        return refinement(this._value);
    }
    toJSON() {
        return {
            type: "discrete",
            value: Serializable.toJSON(this._value),
        };
    }
}
/**
 * @public
 */
(function (Discrete) {
    function isDiscrete(value) {
        return value instanceof Discrete;
    }
    Discrete.isDiscrete = isDiscrete;
})(Discrete || (Discrete = {}));
//# sourceMappingURL=discrete.js.map